import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { UserDataService } from '../../../../shared/services/userData.service';
import { IRecordOfChange } from '../../../../shared/models/eopDocument';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { EopDocumentService } from '../../../../shared/services/eopDocument.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { Icons } from '../../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { DateUtils } from '../../../../shared/helpers/dateUtils';
declare var initFlowbite: any;

@Component({
  selector: 'record-of-changes',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    NgxPaginationModule,
    LucideAngularModule
  ],
  templateUrl: './record-of-changes.component.html',
  styleUrl: './record-of-changes.component.css'
})
export class RecordOfChangesComponent implements OnInit, OnDestroy {
  icons = Icons;
  currentBuildingId: string | null = null;
  recordOfChanges: IRecordOfChange[] = [];
  page = 1;
  itemsPerPage = 30;
  schoolYears: string[] = [];
  selectedSchoolYear: string = '';
  
  loading: boolean = false;
  isSchoolYearDropdownOpen = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private userDataService: UserDataService,
    private eopDocumentService: EopDocumentService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.schoolYears = DateUtils.getSchoolYears(6);
    this.selectedSchoolYear = DateUtils.getCurrentSchoolYear();
    this.loadRecordOfChanges();
        
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        initFlowbite();
      }
    }, 50);
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('#schoolYearDropdownButton') && !target.closest('#schoolYearDropdown')) {
      this.isSchoolYearDropdownOpen = false;
    }
  };
  
  toggleSchoolYearDropdown(): void {
    this.isSchoolYearDropdownOpen = !this.isSchoolYearDropdownOpen;
  }

  handleSchoolYearSelect(year: string): void {
    this.selectedSchoolYear = year;
    this.isSchoolYearDropdownOpen = false;
    this.loadRecordOfChanges();
  }

  loadRecordOfChanges(): void {
    if (this.currentBuildingId && this.selectedSchoolYear) {
      this.loading = true;
      this.eopDocumentService.getRecordOfChanges(this.currentBuildingId, this.selectedSchoolYear).subscribe({
        next: (response: any) => {
          this.loading = false;
          if (response.length > 0) {
            this.recordOfChanges = response;
          } else {
            this.recordOfChanges = [];
          }
          console.log('Record of Changes: ', response);
        },
        error: (error: any) => {
          this.loading = false;
          console.error('Error loading record of changes:', error.message);
        }
      });
    }
  }
}
